import {useFlags} from 'launchdarkly-react-client-sdk';
import {MRT_Row} from 'material-react-table';
import React from 'react';
import {type SearchDisplayCreator} from '@/types/models/creator-crm/creatorCrm';
import VettingStatusChip from '@/components/vetting-status-chip';
import useNavigateToLatestReport from '@/hooks/use-navigate-to-latest-report';
import styles from './VettingStatusCell.module.scss';

type VettingStatusCellProps = {
  row: MRT_Row<SearchDisplayCreator>;
};

function VettingStatusCell({row}: VettingStatusCellProps) {
  const vetting = row.original.brandSafetyVetting;
  const flags = useFlags();
  const handleClick = useNavigateToLatestReport(
    row.original.id,
    flags.fifaRevamp ? 'agency' : undefined,
    'crm'
  );

  return (
    <div className={styles.clickable} onClick={handleClick}>
      <VettingStatusChip
        status={vetting?.vettingDecision || 'ready_for_review'}
        decisionDate={
          vetting?.decisionUpdatedAt
            ? new Date(vetting.decisionUpdatedAt)
            : undefined
        }
        readOnly
        testID="vetting-status-cell-chip"
        className={styles.chip}
      />
    </div>
  );
}

export default VettingStatusCell;
